module.exports = __webpack_public_path__ + "static/assets/94f40e2d91a326342da5980ed39eeacb.svg";